export default "__VITE_ASSET__e95e4cd8__"